import { Injectable } from '@angular/core';
import { ENDPOINTS } from '@app/core/constants/endpoints';
import { Country } from '@app/shared/models/country.model';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClientSkippingInterceptorsService } from '../http-client-skipping-interceptors.service';
import { CountryAdapter } from './country.adapter';

@Injectable()
export class CountryService {
    constructor(
        private http: HttpClientSkippingInterceptorsService,
        private adapter: CountryAdapter
    ) {}

    getCountries(): Observable<Country[]> {
        return this.http.get(`${ENDPOINTS.data.countries}`).pipe(
            map((jsonData: any[]) => {
                return jsonData.map((data: any) => this.adapter.adapt(data));
            }),
            catchError((error) => throwError(() => new Error(error)))
        );
    }

    getCountry(code: string): Observable<Country> {
        return this.http.get(`${ENDPOINTS.data.countries}`).pipe(
            map((jsonData: any[]) => {
                const countries = jsonData.map((data: any) => this.adapter.adapt(data));
                return countries.find((country) => country.code === code);
            }),
            catchError((error) => throwError(() => new Error(error)))
        );
    }
}
